import createStore from './createStore';

export default function createQueryStore(storeName, additionalConfig = {}) {
  const { initialState, reducers } = additionalConfig;

  return createStore({
    storeName,
    initialState: {
      data: [],
      loading: false,
      error: null,
      ...initialState
    },
    reducers: {
      setLoading: (state, action) => {
        state.loading = action.payload;
      },
      setData: (state, action) => {
        state.data = action.payload;
      },
      setError: (state, action) => {
        state.error = action.payload;
      },
      updateData: (state, action) => {
        state.data = { ...state.data, ...action.payload };
      },
      reset: (state) => {
        state.data = [];
        state.loading = false;
        state.error = null;
      },
      ...reducers
    }
  });
}
